<template>
  <div class='daytrips'>
    <!-- <img src='@/assets/nmLogoTekst2.png'> -->
    <h1>Let’s tailor your tour</h1>
    <div style='text-align: justify; width: 90%; margin: auto'>
      <p class='pasus'>
        Tailor made tours are the best way to accomplish all wishes and
        interests related to your travel to the best possible extent. You have
        the opportunity to participate in designing each segment of your travel
        and as a result have a unique tour, different from others. Tailor made
        tours is the perfect choice for individuals, couples, smaller groups...
      </p>
      <p class='pasus'>
        Designing customized tours is an exciting endeavor; it inspires us to
        tailor every tour in a unique way, each time putting different spices in
        our tour stew. Our team has always taken it with enthusiasm and having
        in mind their long-lasting experience, excellent knowledge of the
        terrain, contacts and trusted partners, high level results are
        guaranteed.
      </p>
      <p class='pasus'>
        By completing the questionnaire below you will tell us your preferences
        and we will do our best to tailor the best of the program as well as to
        respond with our offer as soon as possible.
      </p>
      <p class='pasus'>We are looking forward to meeting you in Montenegro!</p>
    </div>
    <div class='container'>
      <div class='row'>
        <div class='col-md-8 offset-md-2 mt-5'>
          <h3 class='titles' style='text-align: left; margin-bottom: 20px'>
            Please fill in the form
          </h3>
          <div class='card p-2 tailor1' style='margin-top: 10vh'>
            <form @submit.prevent='newTailorMade'>
              <h4
                style='
                  text-align: left;
                  color: darkslategray;
                  background-color: rgba(49, 136, 43, 0.3);
                  border-radius: 3px;
                  padding: 3px;
                '
              >
                Personal details:
              </h4>
              <div class='form-group'>
                <label for='title'>Title</label>
                <select
                  placeholder='Choose your title.'
                  required
                  v-model='tailor.title'
                  class='form-control'
                  id='title'
                >
                  <option>MR</option>
                  <option>MRS</option>
                  <option>MISS</option>
                  <option>Ms</option>
                </select>
              </div>
              <div class='form-group'>
                <label for='name'>Name</label>
                <input
                  required
                  v-model='tailor.name'
                  type='text'
                  class='form-control'
                  id='name'
                />
              </div>
              <div class='form-group'>
                <label for='email'>Email address</label>
                <input
                  required
                  v-model='tailor.email'
                  type='email'
                  class='form-control'
                  id='email'
                />
              </div>
              <div class='form-group'>
                <label for='contact'>Contact number</label>
                <input
                  v-model='tailor.contact'
                  type='number'
                  class='form-control'
                  id='contact'
                />
              </div>
              <div class='form-group'>
                <label for='based'>Where are you based?</label>
                <input
                  required
                  v-model='tailor.based'
                  type='text'
                  class='form-control'
                  id='based'
                />
              </div>
              <div class='form-group'>
                <label for='arrival'>Date of arrival</label>
                <input
                  required
                  v-model='tailor.arrival'
                  type='date'
                  class='form-control'
                  id='arrival'
                />
              </div>
              <div class='form-group'>
                <label for='departure'>Date of departure</label>
                <input
                  required
                  v-model='tailor.departure'
                  type='date'
                  class='form-control'
                  id='departure'
                />
              </div>
              <h4
                style='
                  text-align: left;
                  color: darkslategray;
                  background-color: rgba(49, 136, 43, 0.3);
                  border-radius: 3px;
                  padding: 3px;
                  margin-top: 40px;
                '
              >
                Your travel plans:
              </h4>
              <div class='form-group'>
                <label for='adults'>Number of Adults</label>
                <input
                  required
                  v-model='tailor.adults'
                  type='number'
                  class='form-control'
                  id='adults'
                />
              </div>
              <div class='form-group'>
                <label for='children'>Number of children</label>
                <input
                  v-model='tailor.children'
                  type='number'
                  class='form-control'
                  id='children'
                />
              </div>
              <div class='form-group'>
                <label for='childrenage'>Age of children</label>
                <input
                  v-model='tailor.childrenage'
                  type='text'
                  class='form-control'
                  id='childrenage'
                />
              </div>
              <div class='form-group'>
                <label for='accommodation'
                  >Tell us what accommodation level you would prefer</label
                >
                <select
                  placeholder='Choose your accommodation type.'
                  required
                  v-model='tailor.accommodation'
                  class='form-control'
                  id='accommodation'
                >
                  <option>Guesthouses</option>
                  <option>3* Hotel</option>
                  <option>4* Hotel</option>
                  <option>5* Hotel</option>
                  <option>Combined</option>
                </select>
              </div>
              <div class='form-group'>
                <label for='room'>Room type</label>
                <select
                  placeholder='Choose your room type.'
                  required
                  v-model='tailor.room'
                  class='form-control'
                  id='room'
                >
                  <option>Single Room</option>
                  <option>Twin Room</option>
                  <option>Double Room</option>
                  <option>Triple Room</option>
                </select>
              </div>
              <div class='form-group'>
                <label for='food'>Tell us about your food preferences</label>
                <select
                  placeholder=''
                  v-model='tailor.food'
                  class='form-control'
                  id='food'
                >
                  <option>Local cuisine</option>
                  <option>Vegetarian cuisine</option>
                  <option>Mixed</option>
                </select>
              </div>
              <div class='form-group'>
                <label for='vehicle'
                  >Type of vehicle you prefer (only for self-drive tours)</label
                >
                <select
                  placeholder='Choose vehicle type.'
                  v-model='tailor.vehicle'
                  class='form-control'
                  id='vehicle'
                >
                  <option>CAR</option>
                  <option>MINIVAN</option>
                  <option>VAN</option>
                </select>
              </div>
              <div class='form-group'>
                <label for='interests' style='margin-bottom: 0px'
                  >Tell us about your preferences/interests *</label
                >
                <p style='font-size: 0.7em'>
                  *Select multiple choices if you want us to combine different
                  experiences
                </p>
                <v-select
                  v-model='tailor.interests'
                  :options='interestsOptions'
                  multiple
                  id='interests'
                ></v-select>
              </div>
              <div class='form-group'>
                <label for='activities' style='margin-bottom: 0px'
                  >Activities you would like to have on the tour *</label
                >
                <p style='font-size: 0.7em'>
                  *Select multiple choices if you want us to combine different
                  experiences
                </p>
                <v-select
                  v-model='tailor.activities'
                  :options='activitiesOptions'
                  multiple
                  id='activities'
                ></v-select>
              </div>
              <div class='form-group'>
                <label for='guide'>Do you need a guide?</label>
                <select
                  required
                  v-model='tailor.guide'
                  class='form-control'
                  id='guide'
                >
                  <option>Self-drive / without guide</option>
                  <option>Self-drive / Partly-guided</option>
                  <option>Fully-guided / driver</option>
                </select>
              </div>

              <div class='form-group'>
                <label for='message'>Anything else we need to know?</label>
                <textarea
                  style='height: 20vh'
                  placeholder='Enter your message here.'
                  v-model='tailor.message'
                  class='form-control'
                  id='message'
                ></textarea>
              </div>
              <div class='form-group'>
                <button
                  class='btn btn-success'
                  style='background-color: rgba(49, 136, 43, 0.7)'
                  type='submit'
                >
                  Submit
                </button>
                <p
                  style='
                    text-align: left;
                    color: darkslategray;
                    background-color: rgba(49, 136, 43, 0.3);
                    border-radius: 3px;
                    padding: 3px;
                    margin-top: 20px;
                  '
                >
                  You can expect our travel offer within three business days.
                </p>
                <!-- <h4 style='text-align:left;color:darkslategray;margin-top:10px;'>You can expect our travel offer within three business days.</h4> -->
              </div>
              <!-- <span v-if='loader' class='spinner-border spinner-border-sm' role='status'
                                            aria-hidden='true'></span> -->
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  data () {
    return {
      tailor: {
        title: '',
        name: '',
        email: '',
        contact: '',
        based: '',
        arrival: '',
        departure: '',
        adults: '',
        children: '',
        childrenage: '',
        accommodation: '',
        room: '',
        food: '',
        vehicle: '',
        interests: '',
        activities: '',
        guide: '',
        message: ''
      },
      interestsOptions: [
        'Nature sites',
        'Get off the beaten path',
        'Country & people',
        'History and culture',
        'Food & Wine',
        'Rural experiences',
        'Religious sites',
        'Architecture',
        'Art',
        'Photography',
        'Crafts',
        'Botany  ',
        'Personal free time'
      ],
      activitiesOptions: [
        'Trekking',
        'Hiking',
        'Rafting ',
        'Kayaking',
        'Canyoning',
        'Boat cruising',
        'Bird watching',
        'Horse riding',
        'Biking'
      ],
      errors: {}
    }
  },
  //   methods: {
  //     submit() {
  //       this.errors = {};
  //       axios.post('/submit', this.user).then(response => {
  //         alert('Message sent!');
  //       }).catch(error => {
  //         if (error.response.status === 422) {
  //           this.errors = error.response.data.errors || {};
  //         }
  //       });
  //     },
  methods: {
    async newTailorMade () {
      // this.loader = true
      try {
        // debugger;
        let response = await axios.post(
          'https://www.natourmontenegro.com:8081/tailor',
          this.tailor
        )
        console.log(response)
        alert('Your request has been sent.')
        // this.loader = false;
      } catch (err) {
        console.log('error:' + err)
        alert('Ups..something went wrong: ' + err)
        // this.loader = false
      }
    }
  }
}
</script>

<style scoped>
.row {
  display: flex;
  flex-wrap: wrap;
  padding: 0 4px;
}
/* Create four equal columns that sits next to each other */
.column {
  flex: 33%;
  max-width: 33%;
  padding: 0 4px;
}

.column img {
  margin-top: 8px;
  vertical-align: middle;
  width: 100%;
}

/* Responsive layout - makes a two column-layout instead of four columns */
@media screen and (max-width: 800px) {
  .column {
    flex: 50%;
    max-width: 50%;
  }
}

/* Responsive layout - makes the two columns stack on top of each other instead of next to each other */
@media screen and (max-width: 600px) {
  .column {
    flex: 100%;
    max-width: 100%;
  }
}

.centered {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 2vw;
  background-color: rgba(165, 165, 165, 0.6);
  /* opacity: 0.6; */
  border-radius: 5px;
  border: none;
  padding: 0px 20px;
  /* color: #000000; */
}
.centered:hover {
  background: rgba(173, 255, 47, 0.5);
}

.cont {
  position: relative;
  text-align: center;
  color: white;
}
.link {
  text-decoration: none;
}
.daytrips {
  padding-top: 10vw;
}
</style>



// WEBPACK FOOTER //
// src/components/TailorMade.vue